import * as React from "react";
import * as moment from "moment";

export default function BlogPost({ post }: { post: ICTBlogPost }) {
  return (
    <div className="latest-posts-container">
      <div className="col-sm-4">
        <div className="blog-post-image">
          <a href={post.link} target="_blank" rel="noopener noreferrer">
            <img
              src={post.imageUrl}
              alt=""
              className="img-responsive"
              width="150"
              height="119"
            />
          </a>
        </div>
      </div>
      <div className="col-sm-8">
        <h3 className="blog-post-title">
          <a href={post.link} target="_blank" rel="noopener noreferrer">
            {post.title}
          </a>
        </h3>
        <p className="blog-post-date">{moment(post.date).calendar()}</p>
        <p className="blog-post-author">
          <b>By:</b> {post.authorName}
        </p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/home/BlogPost.tsx